import { render } from "./Button.vue?vue&type=template&id=27e13c30"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27e13c30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27e13c30', __exports__)) {
    api.reload('27e13c30', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=27e13c30", () => {
    api.rerender('27e13c30', render)
  })

}


export default __exports__